import styled from "@emotion/styled";
import { Grid2 } from "@mui/material";

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.colors.secondary.minor};
  position: relative;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: 70px;
  }
`;

export const GridContainer = styled(Grid2)`
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    text-align: left;
    flex-direction: row;
    justify-content: space-around;
  }
`;

export const GridItemOne = styled(Grid2)`
  margin-bottom: ${p => p.theme.space[3]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[0]};
  }
`;

export const GridItemTwo = styled(Grid2)`
  margin-bottom: 37px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    margin-bottom: ${p => p.theme.space[0]};
  }
`;

export const Text = styled.p`
  font-size: ${p => p.theme.fontSizes.s};
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
    line-height: normal;
  }
`;

export const DropDownButton = styled.button`
  background-color: transparent;
  font-size: ${p => p.theme.fontSizes.s};
  line-height: 1.5;

  color: ${p => p.theme.colors.secondary.minor};
  border: none;
  cursor: pointer;
  border-bottom: 1px solid transparent;
  transition: border-bottom 0.3s ease;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    font-size: ${p => p.theme.fontSizes.m};
    line-height: 1.6;
  }

  &:hover {
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondary.minor};
  }
`;
